/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { UNSUPPORTED_PAYMENTS } from '@/data/constants/unsupportedPayments';
import { usablePaymentsObj } from '../Content/Payment';
import { CartUsablePaymentInformation } from 'integration/generated/transactions/data-contracts';


export const filterUnSupportedPayments = (usablePayments: usablePaymentsObj) =>{
	(Object.keys(usablePayments) as Array<keyof usablePaymentsObj>).map(key => {
		usablePayments[key] = usablePayments[key]?.filter(
			 	(payment) => !UNSUPPORTED_PAYMENTS.includes(payment.paymentMethodName ?? '')
			 )
	});
	return usablePayments
}

export const findPaymentByPolicyId = (usablePayments: usablePaymentsObj | undefined, policyId:string) =>{
	let payment:CartUsablePaymentInformation | undefined;
	if(usablePayments){
		(Object.keys(usablePayments) as Array<keyof usablePaymentsObj>).forEach(key => {
			payment = usablePayments[key].find((payment) => payment.xumet_policyId === policyId)
		});
		
	}
	return payment;
}
	
